<template>
  <div class="summary-card">
    <div>
      <span>
        {{
          $t('retailSale.cart.subtotalItems', {
            count: formattedItemCount
          })
        }}
      </span>
      <strong>{{ formattedSubtotal }}</strong>
    </div>
    <div>
      <span>{{ $t('retailSale.cart.tax', { rate: formattedVatRate }) }}</span>
      <strong>{{ formattedTaxTotal }}</strong>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '../../utils/currency'

export default {
  name: 'CartSummary',
  props: {
    itemCount: {
      type: Number,
      default: 0
    },
    subtotal: {
      type: Number,
      default: 0
    },
    taxTotal: {
      type: Number,
      default: 0
    },
    vatRate: {
      type: Number,
      default: 0
    },
    currency: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formattedItemCount() {
      return Number(this.itemCount || 0).toFixed(2)
    },
    formattedSubtotal() {
      return formatCurrency(this.subtotal, this.currency)
    },
    formattedTaxTotal() {
      return formatCurrency(this.taxTotal, this.currency)
    },
    formattedVatRate() {
      return `${this.vatRate}%`
    }
  }
}
</script>

<style scoped src="../../styles/cart-summary.css"></style>
